import React from 'react';
import PropTypes from 'prop-types';

import './chatarchivedialog.scss';

const ChatArchiveDialog = ({ ...props }) => {
  const { archived, close, confirm, trans } = props;

  const archiveText = archived ? 'unarchive' : 'archive';
  return (
    <div className="chat-archive-dialog">
      <div className="chat-archive-dialog-box">
        <div className="chat-archive-dialog-box-close">
          <button onClick={close} type="button">
            <i className="material-icons">close</i>
          </button>
        </div>
        <div className="chat-archive-dialog-box-title">
          {trans[`Are you sure you want to ${archiveText} this conversation?`]}
          <br />
          {!archived ? trans['You can unarchive it at any time.'] : null}
        </div>
        <button className="chat-archive-dialog-confirm" onClick={confirm} type="button">
          {trans.Confirm}
        </button>
      </div>
    </div>
  );
};

ChatArchiveDialog.propTypes = {
  archived: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  trans: PropTypes.shape().isRequired,
};

export default ChatArchiveDialog;
